import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { animate, style, transition, trigger } from '@angular/animations';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../../../../services/api.service';

export interface Contact {
  id: number;
  name: string;
  initials: string;
  avatarColor: string;
  category: string;
  phone: string;
  email: string;
  organization?: string;
  role?: string;
  notes?: string;
}

interface Category {
  key: string;
  label: string;
  icon?: string;
  bgColor?: string;
  textColor?: string;
}

@Component({
  selector: 'app-critical-contacts',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './critical-contacts.html',
  styleUrl: './critical-contacts.css',
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(40px)', opacity: 0 }),
        animate('220ms cubic-bezier(0.4,0,0.2,1)',
          style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('180ms cubic-bezier(0.4,0,0.2,1)',
          style({ transform: 'translateX(40px)', opacity: 0 }))
      ])
    ])
  ]
})
export class CriticalContacts {
  activeRoute = 'critical-contacts';
  searchQuery = '';
  activeCategory = 'all';
  selectedContact: Contact | null = null;
  isMobile = window.innerWidth <= 900;
  loading = true;

  allCategories: Category[] = [
    { key: 'all', label: 'All' },
    {
      key: 'banking',
      label: 'Banking',
      icon: 'M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M8 10v11M12 10v11M16 10v11M20 10v11'
    },
    {
      key: 'insurance',
      label: 'Insurance',
      icon: 'M12 2L4 5v5.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm-1.5 11.5l-2.5-2.5 1.06-1.06 1.44 1.44 3.44-3.44L15 9.5l-4.5 4.5z'
    },
    {
      key: 'credit cards',
      label: 'Credit Cards',
      icon:  'M3 5h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1zm2 4h3v3H5V9z',
    },
    {
      key: 'medical',
      label: 'Medical',
      icon: 'M9 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2h-2M9 3a2 2 0 002 2h2a2 2 0 002-2M9 3h6m-3 6v6m-3-3h6',
    },
    {
      key: 'attorney',
      label: 'Attorney',
      icon: 'M12 3a1 1 0 011 1v1h5a1 1 0 010 2h-.5l-1 9H7.5l-1-9H6a1 1 0 010-2h5V4a1 1 0 011-1zM9 17a3 3 0 006 0H9z'
    },
    {
      key: 'employment',
      label: 'Employment',
      icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
    },
    {
      key: 'estate',
      label: 'Estate',
      icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
    },
    {
      key: 'family',
      label: 'Family',
      icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
    },
    {
      key: 'investments',
      label: 'Investments',
      icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
    },
    {
      key: 'tax',
      label: 'Tax',
      icon: 'M9 14l-4-4 4-4M15 10H5m14-5H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2z'
    },
    {
      key: 'utilities',
      label: 'Utilities',
      icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
    }
  ];
  categories: Category[] = [];

  contacts: Contact[] = [];
  filteredContacts: Contact[] = [];
  currentPage = 1;
itemsPerPage = 10;
totalPages = 1;
pages: number[] = [];

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    console.log("Critical Contacts Loaded");

    const beneficiaryId = localStorage.getItem('beneficiaryId');
    console.log("beneficiaryId =", beneficiaryId);

    if (beneficiaryId && beneficiaryId !== 'null') {
      this.loadContacts();
    } else {
      console.warn("No beneficiaryId found in localStorage");
    }

    this.checkScreen();

    window.addEventListener('resize', () => {
      this.checkScreen();
    });

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        const url: string = e.urlAfterRedirects;
        if (url.includes('critical-contacts')) this.activeRoute = 'critical-contacts';
        else if (url.includes('checklist')) this.activeRoute = 'checklist';
        else if (url.includes('memories-stories')) this.activeRoute = 'memories-stories';
      });
  }

  checkScreen(): void {
    this.isMobile = window.innerWidth <= 900;
  }

  getRandomColor(): string {
    const colors = ['#e05252', '#4a6cf7', '#8b90a7', '#d946b4', '#22c55e'];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  loadContacts(): void {
    this.loading = true;
    this.apiService.getCriticalContacts().subscribe({
      next: (res: any) => {
        console.log("Contacts API Response:", res);
        const data = res.data || res.contactDirectories || res.items || [];

        this.contacts = data.map((item: any, index: number) => ({
          id: index + 1,
          name: item.name,
          initials: item.name?.charAt(0).toUpperCase(),
          avatarColor: this.getRandomColor(),
          category: item.category,
          phone: item.phone,
          email: item.email,
          organization: item.organizationName,
          role: item.role,
          notes: item.notes
        }));

       this.filteredContacts = [...this.contacts];

this.totalPages = Math.ceil(
  this.filteredContacts.length / this.itemsPerPage
);

this.pages = Array.from(
  { length: this.totalPages },
  (_, i) => i + 1
);

this.changePage(1);

this.loading = false;
        this.setVisibleCategories();

        if (this.filteredContacts.length > 0) {
          this.selectedContact = this.filteredContacts[0];
        }
      },
      error: (err) => {
        this.loading = false;
        console.error("Critical Contacts Error:", err);
      }
    });
  }

  onSearch(): void {
    this.applyFilters();
  }

  setCategory(key: string): void {
    this.activeCategory = key;
    this.selectedContact = null;
    this.applyFilters();
  }

private applyFilters(): void {

  const query = this.searchQuery.toLowerCase().trim();

  const filtered = this.contacts.filter(c => {

    const matchesCategory =
      this.activeCategory === 'all' ||
      c.category.toLowerCase() ===
      this.activeCategory.toLowerCase();

    const matchesSearch =
      !query ||
      c.name.toLowerCase().includes(query) ||
      c.category.toLowerCase().includes(query) ||
      (c.email?.toLowerCase().includes(query) ?? false);

    return matchesCategory && matchesSearch;
  });

  this.filteredContacts = filtered;

  this.totalPages = Math.ceil(
    filtered.length / this.itemsPerPage
  );

  this.pages = Array.from(
    { length: this.totalPages },
    (_, i) => i + 1
  );

  this.changePage(1);
}


/* ADD HERE ↓↓↓ */

updatePagination(): void {

  this.totalPages = Math.ceil(
    this.contacts.length / this.itemsPerPage
  );

  this.pages = Array.from(
    { length: this.totalPages },
    (_, i) => i + 1
  );
}

changePage(page: number): void {

  if (page < 1 || page > this.totalPages) return;

  this.currentPage = page;

  const query = this.searchQuery.toLowerCase().trim();

  const filtered = this.contacts.filter(c => {

    const matchesCategory =
      this.activeCategory === 'all' ||
      c.category.toLowerCase() ===
      this.activeCategory.toLowerCase();

    const matchesSearch =
      !query ||
      c.name.toLowerCase().includes(query) ||
      c.category.toLowerCase().includes(query) ||
      (c.email?.toLowerCase().includes(query) ?? false);

    return matchesCategory && matchesSearch;
  });

  const start =
    (this.currentPage - 1) * this.itemsPerPage;

  const end = start + this.itemsPerPage;

 this.filteredContacts =
  filtered.slice(start, end);

if (this.filteredContacts.length > 0) {
  this.selectedContact = this.filteredContacts[0];
}
}

/* END HERE ↑↑↑ */


  selectContact(contact: Contact): void {
    this.selectedContact = contact;
    console.log("Selected Contact:", contact);
  }

  closeDetail(): void {
    this.selectedContact = null;
  }

  getCategoryIcon(category: string): string {
    const icons: Record<string, string> = {
      Medical:
        'M9 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2h-2M9 3a2 2 0 002 2h2a2 2 0 002-2M9 3h6m-3 6v6m-3-3h6',
      Banking:
         'M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M8 10v11M12 10v11M16 10v11M20 10v11',
      'Credit Cards':
         'M3 5h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1zm2 4h3v3H5V9z',
      Insurance:
        'M12 2L4 5v5.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm-1.5 11.5l-2.5-2.5 1.06-1.06 1.44 1.44 3.44-3.44L15 9.5l-4.5 4.5z',
      IT:
        'M12 12a5 5 0 100-10 5 5 0 000 10zm-7 9a7 7 0 0114 0H5z',
      Attorney:
        'M12 3a1 1 0 011 1v1h5a1 1 0 010 2h-.5l-1 9H7.5l-1-9H6a1 1 0 010-2h5V4a1 1 0 011-1zM9 17a3 3 0 006 0H9z',
      Employment:
        'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
      Estate:
        'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
      Family:
        'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
      Investments:
        'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6',
      Tax:
        'M9 14l-4-4 4-4M15 10H5m14-5H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2z',
      Utilities:
        'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
    };
    return icons[category] ?? '';
  }

  getCategoryBgColor(category: string): string {
    const bgColors: Record<string, string> = {
      Insurance:      '#dcfce7',
      Medical:        '#fde8e8',
      Banking:        '#e8f0fd',
      'Credit Cards': '#fdf3e8',
      IT:             '#edf8f1',
      Attorney:       '#f3f0fd',
      Employment:     '#e8f4fd',
      Estate:         '#f0fdf4',
      Family:         '#fff7ed',
      Investments:    '#ecfdf5',
      Tax:            '#fef2f2',
      Utilities:      '#fefce8'
    };
    return bgColors[category] ?? '#f1f5f9';
  }

  getCategoryTextColor(category: string): string {
    const textColors: Record<string, string> = {
      Insurance:      '#16a34a',
      Medical:        '#e05252',
      Banking:        '#4a6cf7',
      'Credit Cards': '#e0922a',
      IT:             '#27ae60',
      Attorney:       '#7c3aed',
      Employment:     '#0ea5e9',
      Estate:         '#15803d',
      Family:         '#ea580c',
      Investments:    '#059669',
      Tax:            '#dc2626',
      Utilities:      '#ca8a04'
    };
    return textColors[category] ?? '#64748b';
  }

  callContact(contact: Contact): void {
    window.open(`tel:${contact.phone}`);
  }

  emailContact(contact: Contact): void {
    window.open(`mailto:${contact.email}`);
  }

  openContactMenu(contact: Contact): void {
    console.log('Open menu for', contact.name);
  }

  addContact(): void {
    console.log('Add new contact');
  }

  goBack(): void {
    this.router.navigate(['/beneficiary-home']);
  }
  setVisibleCategories(): void {
  const usedCategories = this.contacts.map((item: any) =>
    item.category.toLowerCase().trim()
  );

  this.categories = this.allCategories.filter(cat =>
    cat.key === 'all' ||
    usedCategories.includes(cat.key.toLowerCase())
  );
}
}